import * as Immutable from "immutable";
const prepareOidcGroupSyncConfig = (formValues, backendId, serviceType) => {
  const { teamSelection = Immutable.Set(), groupsClaim } = formValues;
  return {
    auth_service_backend_id: backendId,
    selection_type: "all",
    selection: teamSelection.toJS(),
    config: {
      type: serviceType,
      groups_claim: groupsClaim
    }
  };
};
export default prepareOidcGroupSyncConfig;
